// The no-access page (design/screens/no-access.html) for a 403 on navigation, and the not-found page. Like the inline
// panel it claims no audit entry and stamps no time: nothing records a refusal (adversarial review 16 Sep 2026, L7).
import { Link, useSearchParams } from "react-router";
import { useSessionView } from "../session/store";
import { Icon } from "../ui/icons";
import { PageHead, rolesSentence } from "./common";

export function NoAccess() {
  const [params] = useSearchParams();
  const s = useSessionView();
  const page = params.get("page") ?? "this page";
  const permission = params.get("permission") ?? undefined;
  const branch = s?.switchableBranches.find((b) => b.id === s.activeBranchId)?.name ?? null;
  return (
    <section className="screen" id="s-no-access">
      <div className="content">
        <PageHead title={page} sub={branch ?? undefined} />
        <div className="panel">
          <div className="empty">
            <Icon name="lock" />
            <h2>You don't have access to {page}</h2>
            <p>{rolesSentence(permission)}</p>
            <div className="row c gap-8">
              <Link className="btn primary" to="/today">Back to Today</Link>
            </div>
            <span className="help">Access is granted under Settings › Users by an Owner or Admin.</span>
          </div>
        </div>
      </div>
    </section>
  );
}

export function NotFound() {
  return (
    <section className="screen" id="s-not-found">
      <div className="content">
        <PageHead title="Not found" />
        <div className="panel">
          <div className="empty">
            <b>There is nothing at this address.</b>
            <span>The link may be old, or the page belongs to a later sprint.</span>
            <div className="row c gap-8"><Link className="btn primary" to="/today">Back to Today</Link></div>
          </div>
        </div>
      </div>
    </section>
  );
}
